import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./4.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A2401"
            data-name="1A2401"
            points="265.3 97.7 291.5 97.7 291.5 119.6 280.1 119.6 280.1 124.8 265.4 124.8 265.3 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1A_2404"
            data-name="1A_2404"
            points="201.6 119.5 201.6 124.8 186.7 124.8 186.7 97.7 212.9 97.7 212.9 119.6 201.6 119.5"
            fill="#231f20"
          />
          <polygon
            id="_1A_2407"
            data-name="1A_2407"
            points="108.1 97.7 134.3 97.7 134.3 119.5 122.8 119.5 122.8 124.8 108.3 124.8 108.1 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1A_2408"
            data-name="1A_2408"
            points="73.1 133.9 94.6 133.9 94.6 144.5 99.8 144.5 99.8 158.9 72.6 158.9 72.6 134 73.1 133.9"
            fill="#231f20"
          />
          <polygon
            id="_1A_2410"
            data-name="1A_2410"
            points="99.8 197 99.8 211.6 72.6 211.6 72.6 185.6 94.5 185.6 94.5 197 99.8 197"
            fill="#231f20"
          />
          <polygon
            id="_1A_2413"
            data-name="1A_2413"
            points="99.9 275.5 99.9 290.1 73.1 290.1 73.1 264.1 94.6 264.1 94.6 275.6 99.9 275.5"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Cx_2402"
            data-name="1Cx_2402"
            points="239.1 97.7 265.3 97.7 265.3 129.6 254.1 129.6 254.1 133.7 239.1 133.7 239.1 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1C_2403"
            data-name="1C_2403"
            points="213.7 97.7 239.1 97.7 239.1 129.6 212.9 129.6 212.9 97.7 213.7 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2405"
            data-name="1Cx_2405"
            points="160.5 97.7 186.7 97.7 186.7 129.6 175.5 129.6 175.5 133.7 160.5 133.7 160.5 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1C_2406"
            data-name="1C_2406"
            points="134.3 97.7 160.5 97.7 160.5 129.6 134.3 129.6 134.3 97.7"
            fill="#231f20"
          />
          <rect
            id="_1C_2409"
            data-name="1C_2409"
            x="72.6"
            y="159.4"
            width="31.9"
            height="26.24"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2411"
            data-name="1Cx_2411"
            points="72.6 211.7 104.5 211.7 104.5 223 108.8 223 108.8 238 72.6 238 72.6 211.7"
            fill="#231f20"
          />
          <polygon
            id="_1C_2412"
            data-name="1C_2412"
            points="104.5 264.2 72.6 264.1 72.6 238 104.4 238 104.5 264.2"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2414"
            data-name="1Cx_2414"
            points="104.5 290.4 104.5 301.5 108.9 301.5 108.9 316.6 73.1 316.6 73.1 290.5 104.5 290.4"
            fill="#231f20"
          />
          <rect
            id="_1B_2415"
            data-name="1B_2415"
            x="38.3"
            y="238.4"
            width="26.7"
            height="25.55"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2416"
            data-name="1Bx_2416"
            points="34 211.7 65.1 211.7 65.1 237.8 38.3 237.8 38.3 226.8 34 226.8 34 211.7"
            fill="#231f20"
          />
          <polygon
            id="_1D_2419"
            data-name="1D_2419"
            points="35.3 117.2 47 105.4 50.7 109.1 57.8 101.9 73.3 117.4 65.5 125.3 65.5 132.5 38.8 132.5 38.8 121 35.3 117.2"
            fill="#231f20"
          />
          <polygon
            id="_1D_2420"
            data-name="1D_2420"
            points="80.4 71.9 92.2 60.1 95.9 63.8 107.5 63.8 107.5 90.1 100.2 90.1 92.7 97.7 77.4 82.4 84.2 75.7 80.4 71.9"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2423"
            data-name="1Bx_2423"
            points="187.5 63.3 197.9 63.3 197.9 59 212.9 59 212.9 90 187.4 90 187.5 63.3"
            fill="#231f20"
          />
          <polygon
            id="_1B_2424"
            data-name="1B_2424"
            points="239.1 63.4 239.1 90.5 212.9 90.5 212.9 63.4 239.1 63.4"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <rect
            id="_2B2_2422"
            data-name="2B2_2422"
            x="147.4"
            y="63.4"
            width="40"
            height="26.96"
            fill="#231f20"
          />
          <polygon
            id="_2B1_2421"
            data-name="2B1_2421"
            points="108.7 63.4 147.4 63.4 147.4 90.3 108.1 90.3 108.1 63.4 108.7 63.4"
            fill="#231f20"
          />
          <path
            id="_2Bx2_2418"
            data-name="2Bx2_2418"
            d="M33.6,133.2H65V172H38.3V160.1H33.7S33.1,133.2,33.6,133.2Z"
            fill="#231f20"
          />
          <polygon
            id="_2B1_2417"
            data-name="2B1_2417"
            points="38.3 180.7 38.3 172 65 172 65.1 211.7 38.2 211.7 38.3 180.7"
            fill="#231f20"
          />
        </g>
      </g>
      <g id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(272.7 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2401
          </text>
          <text
            transform="translate(247.3 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2402
          </text>
          <text
            transform="translate(221.2 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2403
          </text>
          <text
            transform="translate(194.9 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2404
          </text>
          <text
            transform="translate(169.1 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2405
            <tspan
              fontSize="5.39"
              fill="#a7a9ac"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              <tspan x="-6.9" y="6.5">
                无障碍设施
              </tspan>
            </tspan>
          </text>
          <text
            transform="translate(143.1 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2406
          </text>
          <text
            transform="translate(116.8 133.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2407
          </text>
          <text
            transform="translate(105.1 149.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2408
          </text>
          <text
            transform="translate(110.6 175.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2409
          </text>
          <text
            transform="translate(110.6 202)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2410
          </text>
          <text
            transform="translate(110.6 227.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2411
          </text>
          <text
            transform="translate(110.6 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2412
          </text>
          <text
            transform="translate(110.6 279.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2413
          </text>
          <text
            transform="translate(110.6 306.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2414
          </text>
          <text
            transform="translate(73.1 65.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2420
          </text>
          <text
            transform="translate(29 105.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2419
          </text>
          <text
            transform="translate(121.8 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2421
          </text>
          <text
            transform="translate(161 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2422
          </text>
          <text
            transform="translate(193.8 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2423
          </text>
          <text
            transform="translate(218.8 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2424
          </text>
          <text
            transform="translate(12.6 156.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2418
          </text>
          <text
            transform="translate(12.6 194.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2417
          </text>
          <text
            transform="translate(12.6 227.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2416
          </text>
          <text
            transform="translate(12.6 253.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2415
          </text>
          <text
            transform="translate(193.7 219.6)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">4</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(272.8 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2401
          </text>
          <text
            transform="translate(247.3 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2402
          </text>
          <text
            transform="translate(221.3 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2403
          </text>
          <text
            transform="translate(195 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2404
          </text>
          <text
            transform="translate(169.2 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2405
            <tspan fontSize="5">
              <tspan x="-2.2" y="4">
                для людей с
              </tspan>
              <tspan x="-4.1" y="8">
                ограниченными
              </tspan>
              <tspan x="-4.1" y="12">
                возможностями
              </tspan>
            </tspan>
          </text>
          <text
            transform="translate(143.2 141.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2406
          </text>
          <text
            transform="translate(116.8 133.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2407
          </text>
          <text
            transform="translate(105.2 149.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2408
          </text>
          <text
            transform="translate(110.7 175.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2409
          </text>
          <text
            transform="translate(110.7 202)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2410
          </text>
          <text
            transform="translate(110.7 227.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2411
          </text>
          <text
            transform="translate(110.7 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2412
          </text>
          <text
            transform="translate(110.7 279.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2413
          </text>
          <text
            transform="translate(110.7 306.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2414
          </text>
          <text
            transform="translate(73.2 65.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2420
          </text>
          <text
            transform="translate(29.1 105.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2419
          </text>
          <text
            transform="translate(121.9 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2421
          </text>
          <text
            transform="translate(161.1 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2422
          </text>
          <text
            transform="translate(193.8 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2423
          </text>
          <text
            transform="translate(218.9 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2424
          </text>
          <text
            transform="translate(12.7 156.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2418
          </text>
          <text
            transform="translate(12.7 194.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2417
          </text>
          <text
            transform="translate(12.7 227)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2416
          </text>
          <text
            transform="translate(12.7 253.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2415
          </text>
          <text
            transform="translate(185.9 219.6)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            4-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(272.8 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2401
          </text>
          <text
            transform="translate(247.3 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2402
          </text>
          <text
            transform="translate(221.2 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2403
          </text>
          <text
            transform="translate(194.9 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2404
          </text>
          <text
            transform="translate(169.2 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2405
            <tspan fontSize="5">
              <tspan x="-4" y="6">
                Handicap
              </tspan>
            </tspan>
          </text>
          <text
            transform="translate(143.1 141.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2406
          </text>
          <text
            transform="translate(116.8 133.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2407
          </text>
          <text
            transform="translate(105.1 149.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2408
          </text>
          <text
            transform="translate(110.6 175.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2409
          </text>
          <text
            transform="translate(110.6 202)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2410
          </text>
          <text
            transform="translate(110.6 227.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2411
          </text>
          <text
            transform="translate(110.6 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2412
          </text>
          <text
            transform="translate(110.6 279.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2413
          </text>
          <text
            transform="translate(110.6 306.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2414
          </text>
          <text
            transform="translate(73.1 65.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2420
          </text>
          <text
            transform="translate(29 105.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2419
          </text>
          <text
            transform="translate(121.9 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2421
          </text>
          <text
            transform="translate(161.1 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2422
          </text>
          <text
            transform="translate(193.8 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2423
          </text>
          <text
            transform="translate(218.9 53)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2424
          </text>
          <text
            transform="translate(12.6 156.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2418
          </text>
          <text
            transform="translate(12.6 194.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2417
          </text>
          <text
            transform="translate(12.6 227.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2416
          </text>
          <text
            transform="translate(12.6 253.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2415
          </text>
          <text
            transform="translate(182.5 219.6)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            4th Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/4.js